import { Component, OnInit, ViewChild } from '@angular/core';
import { Hellosign } from '@app/models/hellosign';
import * as HelloSign from 'hellosign-embedded';
import { HellosignSigningUrl } from '@app/models/hellosign-signing-url';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthorizationService } from '@app/services/authorization.service';
import { ArisMessageService } from '@app/services/aris-message.service';
import { EsignDocument } from '@app/models/esign-document';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ArisMessageCodes } from '@app/utilities/aris-message-codes'
import { MatSort } from '@angular/material/sort';
import { LocalStorageUtilities } from '@app/utilities/local-storage-utilities';
import { PersonPortalState } from '@app/models/person-portal-state';

@Component({
  selector: 'app-esign',
  templateUrl: './esign.component.html',
  styleUrls: ['./esign.component.css']
})
export class EsignComponent implements OnInit {

  public eSignDocuments: EsignDocument[] = [];
  private signedDocumentArisMessageCode: number;

  public eSignDocumentsDataSource = new MatTableDataSource<EsignDocument>(this.eSignDocuments);
  public eSignDocumentsColumns: string[] = ['description', 'templateId'];

  private client: HelloSign;

  @ViewChild("eSignDocumentsPaginator", { static: true })
  public eSignDocumentsPaginator: MatPaginator;
  @ViewChild("eSignDocumentsSort", { static: true })
  public eSignDocumentsSort: MatSort;


  constructor(private authorizationService: AuthorizationService,
    private arisMessageService: ArisMessageService) { }

  ngOnInit(): void {
    this.eSignDocumentsDataSource.sort = this.eSignDocumentsSort;
    // Table paginator.
    this.eSignDocumentsDataSource.paginator = this.eSignDocumentsPaginator;
    // Force table to sort decendingly on tradeDate. 
    this.eSignDocumentsSort.sort({ id: 'description', start: 'asc', disableClear: false });
    //this.eSignDocuments = [];
    // Load the model.   
    this.getESignDocuments();
    // Initialize signing client.
    this.initSigningClient();

  }

  private initSigningClient() {
    this.client = new HelloSign({
      clientId: 'abe52dd8376ea38caac9e517a2e4a543',
    });    
    // Notify Aris that the customer has signed a document.
    this.client.on('sign', () => {      
      /**
       * Send signing event to ARIS.
       */      
    });
    
  }

  /**
   * Called from the "Main" module when the selected account changes.
   */
  public refreshUI(): void {
  }

  /**
   * This is called from the Main component when the user's session
   * is about to timeout.
   * 
   * If the user is signing a document when this occurs, the document
   * is unceremoneously closed.  
   */
  public onTimeout() {
    this.client.close();
  }

  private getESignDocuments(): void {
    this.authorizationService.getESignDocuments().subscribe({
      next: (eSignDocuments: EsignDocument[]) => {
        eSignDocuments.forEach(document => {
          this.eSignDocuments.push(document);
          this.eSignDocumentsDataSource.data = this.eSignDocuments;
        });
      },
      error: (err: any) => {
        console.log(`Failed loading eSign documents`);
      }
    })
  }

  public getSigningDocument(row: EsignDocument) {
    let templateId: string = row.templateId;
    switch (row.id) {
      /*
       * Row ID for Form W8. Used when sending notifications to ARIS.
       */
      case 1: {        
        break;
      }
    }
    this.getSigningRequest(templateId);
  }

  /**
   * Make HelloSign signature request.
   * 
   * @param date 
   */
  public getSigningRequest(templateId: string): void {

    let personPortalState: PersonPortalState = LocalStorageUtilities.getPersonPortalState();
    let accountName: string = personPortalState.mxna.accountName;
    let emailAddress: string = personPortalState.mxna.mxk9.email;
    let account: string = personPortalState.mxna.account;
    let accountRep: string = personPortalState.mxna.acctRep;

    this.authorizationService.getSignatureRequest(accountName, emailAddress, templateId, account, accountRep).subscribe({
      next: (hellosign: Hellosign) => {
        // Get signing url.  
        this.authorizationService.getSigningUrl(hellosign.signature_request.signatures[0].signature_id).subscribe({
          next: (hellosignSigningUrl: HellosignSigningUrl) => {
            this.client.open(`${hellosignSigningUrl.embedded.sign_url}`, {
              hideHeader: true,
              locale: "en-US",
              testMode: true
            }
            );
          },
          error: (err: HttpErrorResponse) => {
            console.log("Embedded Signing URL request failed.");
          }
        });
      },
      error: (err: HttpErrorResponse) => {
        console.log("Signature request failed.");
      }
    });
  }

}
